import { toast } from 'react-toastify';
import jsPDF from "jspdf";

const  generateRandomId = ()  =>{
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomId = '';
    for (let i = 0; i < 10; i++) {
      randomId += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return randomId;
  }

  function formatTime(time) {
     // Split the time string into hours, minutes, and seconds
  const [hours, minutes] = time.split(':');

  // Create a new Date object and set the time
  const date = new Date();
  date.setHours(hours, minutes);

  // Format the time to include AM/PM
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true, // Ensures AM/PM is included
  });
  }

  function formatDate(inputDate) {
    // Create a Date object from the input
    const date = new Date(inputDate);
  
    // Options for formatting the date
    const options = {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
  
    // Format the date to the desired string
    return date.toLocaleString("en-US", options);
  }
  


  function convertTo12HourFormat(time24) {
    // Split the time string into hours, minutes, and seconds
    const [hours, minutes, seconds] = time24.split(":").map(Number);
  
    // Calculate hours for 12-hour format
    const period = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12; // Convert 0 or 24-hour to 12-hour format
  
    // Format the result
    return `${hours12}:${minutes.toString().padStart(2, "0")} ${period}`;
  }


  function extractDateFromISO(isoString) {
    // Parse the ISO string into a Date object
    const date = new Date(isoString);

    // Format the date into YYYY-MM-DD format
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}
// Success Toast
 const showSuccessToast = (message, time , options = {}) => {
  toast.success(message, {
    position: 'top-right',
    autoClose: time,
    ...options,
  });
};

// Error Toast
 const showErrorToast = (message, time , options = {}) => {
  toast.error(message, {
    position: 'top-right',
    autoClose: time,
    ...options,
  });
};

// Info Toast
 const showInfoToast = (message, time , options = {}) => {
  toast.info(message, {
    position: "top-right",
    autoClose: time,
    ...options,
  });
};

// Warning Toast
 const showWarningToast = (message, time , options = {}) => {
  toast.warn(message, {
    position: "top-right",
    autoClose: time,
    ...options,
  });
};
  


const generatePDF = (messages, summary) => {
  if (!Array.isArray(messages)) {
    console.error("Data is not an array.");
    return;
  }

  const doc = new jsPDF();
  const margin = 10; // Set margin for the document
  let y = margin; // Start at the top margin
  const lineHeight = 10; // Line height for each message

  // Add title
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Conversation Log", margin, y);
  y += lineHeight * 1.5;

  // Loop through messages
  messages.forEach((message) => {
    const { role, content, timestamp } = message;

    // Check if required fields exist
    if (!role || !content || !timestamp) {
      console.warn("Message is missing required fields:", message);
      return; // Skip incomplete messages
    }

    // Role styling
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(role === "user" ? "blue" : "green");
    doc.text(`${role.toUpperCase()} (${new Date(timestamp).toLocaleString()}):`, margin, y);
    y += lineHeight;

    // Message content
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);

    // Wrap text for long content
    const wrappedText = doc.splitTextToSize(content, 180);
    wrappedText.forEach((line) => {
      doc.text(line, margin, y);
      y += lineHeight;
    });

    y += lineHeight * 0.5; // Add spacing between messages

    // Add new page if needed
    if (y + lineHeight > doc.internal.pageSize.height - margin) {
      doc.addPage();
      y = margin;
    }
  });
  console.log(summary)
  // Save the PDF
  const timestamp = new Date().toISOString();
  doc.save(`Conversation_Log_${timestamp}.pdf`);
};



export{
  generateRandomId, 
  formatTime,
  formatDate,
  convertTo12HourFormat,
  showInfoToast,
  showWarningToast,
  showSuccessToast,
  showErrorToast,
  extractDateFromISO,
  generatePDF
}

